import { useMemo } from 'react'
import { useAtomValue } from 'jotai'
import type { CustomBreadCrumbConfig } from 'components/Breadcrumbs'
import { PathNames } from 'constants/General'
import { earnDetailsBreadcrumbAtom } from '../atoms/breadcrumbAtom'

export const useEarnDetailsBreadcrumbs = (): CustomBreadCrumbConfig[] => {
  const asset = useAtomValue(earnDetailsBreadcrumbAtom)

  return useMemo(
    () => [
      {
        title: 'earn.title',
        link: PathNames.EARN,
      },
      ...(asset ? [{ title: asset }] : []),
    ],
    [asset]
  )
}
